import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Coins, Sparkles } from 'lucide-react';

interface NoCreditsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpgrade: () => void;
}

export function NoCreditsModal({ open, onOpenChange, onUpgrade }: NoCreditsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto p-4 bg-primary/10 rounded-full mb-4">
            <Coins className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-center text-xl">
            You're out of credits!
          </DialogTitle>
          <DialogDescription className="text-center">
            Get 10 credits for just $3 and continue creating amazing image adaptations.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-4">
          <Button
            onClick={onUpgrade}
            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            <Sparkles className="h-4 w-4 mr-2" />
            Get 10 Credits for $3
          </Button>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
          >
            Maybe later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
